import { type AxiosError } from 'axios'
import {
  type QueryFunctionContext,
  type UseQueryOptions,
  useQuery
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { getEndpointWithParams } from 'queries/queries-utils'
import { serviceQueryKeys } from 'queries/services/query-keys'

import type { UserDefinedService } from 'types/api/services/service'

async function fetchServiceById({
  queryKey
}: QueryFunctionContext<ReturnType<typeof serviceQueryKeys.getById>>) {
  const endpointWithParams = getEndpointWithParams(...queryKey)
  return await fetchQueryData<UserDefinedService>(endpointWithParams)
}

export function useGetServiceById(
  serviceId: string | undefined,
  options?: Omit<
    UseQueryOptions<UserDefinedService, AxiosError>,
    'queryKey' | 'queryFn'
  >
) {
  const { currentTeamId } = useAuth()
  const queryKey = serviceId
    ? serviceQueryKeys.getById({ serviceId, teamId: currentTeamId })
    : undefined

  return useQuery({
    ...options,
    queryKey,
    queryFn: fetchServiceById
  })
}
